import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type Maybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Long: any;
  UUID: any;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

export type Authority = {
  __typename?: 'Authority';
  createdAt?: Maybe<Scalars['DateTime']>;
  cvr: Scalars['String'];
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AuthorityCreateRequestInput = {
  cvr: Scalars['String'];
  name: Scalars['String'];
};

export type AuthorityFilterInput = {
  and?: Maybe<Array<AuthorityFilterInput>>;
  createdAt?: Maybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  cvr?: Maybe<StringOperationFilterInput>;
  id?: Maybe<ComparableGuidOperationFilterInput>;
  isActive?: Maybe<BooleanOperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  or?: Maybe<Array<AuthorityFilterInput>>;
  type?: Maybe<StringOperationFilterInput>;
  updatedAt?: Maybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
};

export type AuthorityModel = {
  __typename?: 'AuthorityModel';
  cvr: Scalars['String'];
  deviceCount: Scalars['Int'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AuthoritySortInput = {
  createdAt?: Maybe<SortEnumType>;
  cvr?: Maybe<SortEnumType>;
  id?: Maybe<SortEnumType>;
  isActive?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  type?: Maybe<SortEnumType>;
  updatedAt?: Maybe<SortEnumType>;
};

export type AuthorityUpdateRequestInput = {
  cvr: Scalars['String'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AuthorizeDirective = {
  __typename?: 'AuthorizeDirective';
  apply: ApplyPolicy;
  policy?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
};

export type BooleanOperationFilterInput = {
  eq?: Maybe<Scalars['Boolean']>;
  neq?: Maybe<Scalars['Boolean']>;
};

export type ComparableGuidOperationFilterInput = {
  eq?: Maybe<Scalars['UUID']>;
  gt?: Maybe<Scalars['UUID']>;
  gte?: Maybe<Scalars['UUID']>;
  in?: Maybe<Array<Scalars['UUID']>>;
  lt?: Maybe<Scalars['UUID']>;
  lte?: Maybe<Scalars['UUID']>;
  neq?: Maybe<Scalars['UUID']>;
  ngt?: Maybe<Scalars['UUID']>;
  ngte?: Maybe<Scalars['UUID']>;
  nin?: Maybe<Array<Scalars['UUID']>>;
  nlt?: Maybe<Scalars['UUID']>;
  nlte?: Maybe<Scalars['UUID']>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
  ngt?: Maybe<Scalars['Int']>;
  ngte?: Maybe<Scalars['Int']>;
  nin?: Maybe<Array<Scalars['Int']>>;
  nlt?: Maybe<Scalars['Int']>;
  nlte?: Maybe<Scalars['Int']>;
};

export type ComparableNullableOfDateTimeOffsetOperationFilterInput = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  ngt?: Maybe<Scalars['DateTime']>;
  ngte?: Maybe<Scalars['DateTime']>;
  nin?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  nlt?: Maybe<Scalars['DateTime']>;
  nlte?: Maybe<Scalars['DateTime']>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  ngt?: Maybe<Scalars['DateTime']>;
  ngte?: Maybe<Scalars['DateTime']>;
  nin?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  nlt?: Maybe<Scalars['DateTime']>;
  nlte?: Maybe<Scalars['DateTime']>;
};

export type ComparableNullableOfGuidOperationFilterInput = {
  eq?: Maybe<Scalars['UUID']>;
  gt?: Maybe<Scalars['UUID']>;
  gte?: Maybe<Scalars['UUID']>;
  in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  lt?: Maybe<Scalars['UUID']>;
  lte?: Maybe<Scalars['UUID']>;
  neq?: Maybe<Scalars['UUID']>;
  ngt?: Maybe<Scalars['UUID']>;
  ngte?: Maybe<Scalars['UUID']>;
  nin?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  nlt?: Maybe<Scalars['UUID']>;
  nlte?: Maybe<Scalars['UUID']>;
};

export type Device = {
  __typename?: 'Device';
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceId: Scalars['String'];
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organisationId: Scalars['UUID'];
  stationNumber?: Maybe<Scalars['String']>;
  templateId: Scalars['UUID'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DeviceCreateRequestInput = {
  deviceId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  organisationId: Scalars['UUID'];
  stationNumber?: Maybe<Scalars['String']>;
  templateId: Scalars['UUID'];
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  deviceId: Scalars['String'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  organisationId: Scalars['UUID'];
  stationNumber?: Maybe<Scalars['String']>;
  telemetryData?: Maybe<TelemetryData>;
  templateId: Scalars['UUID'];
  templateName: Scalars['String'];
};

export type DeviceUpdateRequestInput = {
  deviceId: Scalars['String'];
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  stationNumber?: Maybe<Scalars['String']>;
  templateId: Scalars['UUID'];
};

/** Define mutations supported by the API */
export type GraphMutationApi = {
  __typename?: 'GraphMutationApi';
  /** Create an authority */
  createAuthority: Authority;
  /** Create a device */
  createDevice: Device;
  /** Create a template with its attributes */
  createTemplate: Template;
  /** Delete an authority */
  deleteAuthority: Scalars['UUID'];
  /** Delete a device */
  deleteDevice: Scalars['UUID'];
  /** Delete a template */
  deleteTemplate: Scalars['UUID'];
  /** Update an authority */
  updateAuthority: Scalars['UUID'];
  /** Update a device */
  updateDevice: Scalars['UUID'];
  /** Update a template */
  updateTemplate: Scalars['UUID'];
};

/** Define mutations supported by the API */
export type GraphMutationApiCreateAuthorityArgs = {
  request: AuthorityCreateRequestInput;
};

/** Define mutations supported by the API */
export type GraphMutationApiCreateDeviceArgs = {
  request: DeviceCreateRequestInput;
};

/** Define mutations supported by the API */
export type GraphMutationApiCreateTemplateArgs = {
  request: TemplateCreateRequestInput;
};

/** Define mutations supported by the API */
export type GraphMutationApiDeleteAuthorityArgs = {
  id: Scalars['UUID'];
};

/** Define mutations supported by the API */
export type GraphMutationApiDeleteDeviceArgs = {
  id: Scalars['UUID'];
};

/** Define mutations supported by the API */
export type GraphMutationApiDeleteTemplateArgs = {
  id: Scalars['UUID'];
};

/** Define mutations supported by the API */
export type GraphMutationApiUpdateAuthorityArgs = {
  request: AuthorityUpdateRequestInput;
};

/** Define mutations supported by the API */
export type GraphMutationApiUpdateDeviceArgs = {
  request: DeviceUpdateRequestInput;
};

/** Define mutations supported by the API */
export type GraphMutationApiUpdateTemplateArgs = {
  request: TemplateUpdateRequestInput;
};

/** Define queries supported by the API */
export type GraphQueryApi = {
  __typename?: 'GraphQueryApi';
  /** Query authorities */
  authorities: Array<Authority>;
  /** Query authorities and devices count */
  authoritiesAndDevicesCount: Array<AuthorityModel>;
  /** Find an authority by ID. If not found, a null is returned */
  authority?: Maybe<Authority>;
  /** Find an authority with device counts by ID. If not found, a null is returned */
  authorityAndDevicesCount?: Maybe<AuthorityModel>;
  /** Check if a device exists in the system or an organization. If not found, throw exception */
  checkExistingDevice?: Maybe<DeviceModel>;
  /** Find a device by ID. If not found, a null is returned */
  device?: Maybe<DeviceModel>;
  /** Find a device by DeviceID. If not found, a null is returned */
  deviceByDeviceId?: Maybe<DeviceModel>;
  /** Query devices */
  devices: Array<DeviceModel>;
  /** Get user context profile */
  profile: UserProfile;
  /** Query stancodes */
  stancodes: Array<Stancode>;
  /** Find a template by ID. If not found, a null is returned */
  template?: Maybe<Template>;
  /** Find an template with device counts by ID. If not found, a null is returned */
  templateAndDevicesCount?: Maybe<TemplateModel>;
  /** Query templates */
  templates: Array<Template>;
  /** Query template and devices count */
  templatesAndDevicesCount: Array<TemplateModel>;
  /** Query templates for device */
  templatesForDevice: Array<TemplatesDeviceResponse>;
};

/** Define queries supported by the API */
export type GraphQueryApiAuthoritiesArgs = {
  order?: Maybe<Array<AuthoritySortInput>>;
  where?: Maybe<AuthorityFilterInput>;
};

/** Define queries supported by the API */
export type GraphQueryApiAuthorityArgs = {
  id: Scalars['UUID'];
};

/** Define queries supported by the API */
export type GraphQueryApiAuthorityAndDevicesCountArgs = {
  id: Scalars['UUID'];
};

/** Define queries supported by the API */
export type GraphQueryApiCheckExistingDeviceArgs = {
  deviceId: Scalars['String'];
  organisationId: Scalars['UUID'];
};

/** Define queries supported by the API */
export type GraphQueryApiDeviceArgs = {
  id: Scalars['UUID'];
};

/** Define queries supported by the API */
export type GraphQueryApiDeviceByDeviceIdArgs = {
  deviceId: Scalars['String'];
};

/** Define queries supported by the API */
export type GraphQueryApiDevicesArgs = {
  organisationId: Scalars['UUID'];
};

/** Define queries supported by the API */
export type GraphQueryApiStancodesArgs = {
  order?: Maybe<Array<StancodeSortInput>>;
  where?: Maybe<StancodeFilterInput>;
};

/** Define queries supported by the API */
export type GraphQueryApiTemplateArgs = {
  id: Scalars['UUID'];
};

/** Define queries supported by the API */
export type GraphQueryApiTemplateAndDevicesCountArgs = {
  id: Scalars['UUID'];
};

/** Define queries supported by the API */
export type GraphQueryApiTemplatesArgs = {
  order?: Maybe<Array<TemplateSortInput>>;
  where?: Maybe<TemplateFilterInput>;
};

export type ListFilterInputTypeOfTemplateAttributeFilterInput = {
  all?: Maybe<TemplateAttributeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<TemplateAttributeFilterInput>;
  some?: Maybe<TemplateAttributeFilterInput>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Stancode = {
  __typename?: 'Stancode';
  additionalDescriptionText?: Maybe<Scalars['String']>;
  applicantIdentificationText?: Maybe<Scalars['String']>;
  codeReference: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  descriptionText?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  lastUpdateDate?: Maybe<Scalars['DateTime']>;
  obsolescenceDate?: Maybe<Scalars['DateTime']>;
  referenceTypeName?: Maybe<Scalars['String']>;
  scCode: Scalars['Int'];
  stancodeGuidKey: Scalars['UUID'];
  stancodeListId: Scalars['UUID'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StancodeFilterInput = {
  additionalDescriptionText?: Maybe<StringOperationFilterInput>;
  and?: Maybe<Array<StancodeFilterInput>>;
  applicantIdentificationText?: Maybe<StringOperationFilterInput>;
  codeReference?: Maybe<ComparableInt32OperationFilterInput>;
  createdAt?: Maybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  creationDate?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  descriptionText?: Maybe<StringOperationFilterInput>;
  id?: Maybe<ComparableGuidOperationFilterInput>;
  isDeleted?: Maybe<BooleanOperationFilterInput>;
  lastUpdateDate?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  obsolescenceDate?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: Maybe<Array<StancodeFilterInput>>;
  referenceTypeName?: Maybe<StringOperationFilterInput>;
  scCode?: Maybe<ComparableInt32OperationFilterInput>;
  stancodeGuidKey?: Maybe<ComparableGuidOperationFilterInput>;
  stancodeListId?: Maybe<ComparableGuidOperationFilterInput>;
  type?: Maybe<StringOperationFilterInput>;
  updatedAt?: Maybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
};

export type StancodeSortInput = {
  additionalDescriptionText?: Maybe<SortEnumType>;
  applicantIdentificationText?: Maybe<SortEnumType>;
  codeReference?: Maybe<SortEnumType>;
  createdAt?: Maybe<SortEnumType>;
  creationDate?: Maybe<SortEnumType>;
  descriptionText?: Maybe<SortEnumType>;
  id?: Maybe<SortEnumType>;
  isDeleted?: Maybe<SortEnumType>;
  lastUpdateDate?: Maybe<SortEnumType>;
  obsolescenceDate?: Maybe<SortEnumType>;
  referenceTypeName?: Maybe<SortEnumType>;
  scCode?: Maybe<SortEnumType>;
  stancodeGuidKey?: Maybe<SortEnumType>;
  stancodeListId?: Maybe<SortEnumType>;
  type?: Maybe<SortEnumType>;
  updatedAt?: Maybe<SortEnumType>;
};

export type StringOperationFilterInput = {
  and?: Maybe<Array<StringOperationFilterInput>>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  ncontains?: Maybe<Scalars['String']>;
  nendsWith?: Maybe<Scalars['String']>;
  neq?: Maybe<Scalars['String']>;
  nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  nstartsWith?: Maybe<Scalars['String']>;
  or?: Maybe<Array<StringOperationFilterInput>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type TelemetryData = {
  __typename?: 'TelemetryData';
  dataLastReceived: Scalars['DateTime'];
  deviceId: Scalars['String'];
  latestPayload: Scalars['String'];
};

export type Template = {
  __typename?: 'Template';
  attributes: Array<TemplateAttribute>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TemplateAttribute = {
  __typename?: 'TemplateAttribute';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  sc1009Id?: Maybe<Scalars['UUID']>;
  sc1187Id?: Maybe<Scalars['UUID']>;
  sensorMapping: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
};

export type TemplateAttributeCreateModelInput = {
  description?: Maybe<Scalars['String']>;
  sc1009Id: Scalars['UUID'];
  sc1187Id: Scalars['UUID'];
  sensorMapping: Scalars['String'];
};

export type TemplateAttributeDevice = {
  __typename?: 'TemplateAttributeDevice';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  sc1009Name?: Maybe<Scalars['String']>;
  sc1187Name?: Maybe<Scalars['String']>;
  sensorMapping: Scalars['String'];
};

export type TemplateAttributeFilterInput = {
  and?: Maybe<Array<TemplateAttributeFilterInput>>;
  description?: Maybe<StringOperationFilterInput>;
  id?: Maybe<ComparableGuidOperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  or?: Maybe<Array<TemplateAttributeFilterInput>>;
  sc1009Id?: Maybe<ComparableNullableOfGuidOperationFilterInput>;
  sc1187Id?: Maybe<ComparableNullableOfGuidOperationFilterInput>;
  sensorMapping?: Maybe<StringOperationFilterInput>;
  unit?: Maybe<StringOperationFilterInput>;
};

export type TemplateAttributeModel = {
  __typename?: 'TemplateAttributeModel';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  sc1009Id?: Maybe<Scalars['UUID']>;
  sc1187Id?: Maybe<Scalars['UUID']>;
  sensorMapping: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
};

export type TemplateAttributeUpdateModelInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  sc1009Id: Scalars['UUID'];
  sc1187Id: Scalars['UUID'];
  sensorMapping: Scalars['String'];
};

export type TemplateCreateRequestInput = {
  attributes: Array<TemplateAttributeCreateModelInput>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  templateId: Scalars['Long'];
};

export type TemplateFilterInput = {
  and?: Maybe<Array<TemplateFilterInput>>;
  attributes?: Maybe<ListFilterInputTypeOfTemplateAttributeFilterInput>;
  createdAt?: Maybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  id?: Maybe<ComparableGuidOperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  or?: Maybe<Array<TemplateFilterInput>>;
  templateId?: Maybe<StringOperationFilterInput>;
  type?: Maybe<StringOperationFilterInput>;
  updatedAt?: Maybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
};

export type TemplateModel = {
  __typename?: 'TemplateModel';
  attributes: Array<TemplateAttributeModel>;
  description?: Maybe<Scalars['String']>;
  deviceCount: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type TemplateSortInput = {
  createdAt?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
  id?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  templateId?: Maybe<SortEnumType>;
  type?: Maybe<SortEnumType>;
  updatedAt?: Maybe<SortEnumType>;
};

export type TemplateUpdateRequestInput = {
  attributes: Array<TemplateAttributeUpdateModelInput>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  templateId: Scalars['Long'];
};

export type TemplatesDeviceResponse = {
  __typename?: 'TemplatesDeviceResponse';
  attributes: Array<TemplateAttributeDevice>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  company: Scalars['String'];
  cvr: Scalars['String'];
  email: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  isAuthority: Scalars['Boolean'];
  isAuthorityActive?: Maybe<Scalars['Boolean']>;
  isAuthorityExisting: Scalars['Boolean'];
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
  userId: Scalars['String'];
};

export type GetProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfileQuery = {
  __typename?: 'GraphQueryApi';
  profile: {
    __typename?: 'UserProfile';
    userId: string;
    name: string;
    email: string;
    cvr: string;
    company: string;
    roles: Array<string>;
    isAdmin: boolean;
    isAuthority: boolean;
    isAuthorityExisting: boolean;
    isAuthorityActive?: boolean | undefined;
  };
};

export type CreateAuthorityMutationVariables = Exact<{
  input: AuthorityCreateRequestInput;
}>;

export type CreateAuthorityMutation = {
  __typename?: 'GraphMutationApi';
  createAuthority: {
    __typename?: 'Authority';
    id: any;
    name: string;
    cvr: string;
    isActive?: boolean | undefined;
    createdAt?: any | undefined;
    updatedAt?: any | undefined;
  };
};

export type DeleteAuthorityMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type DeleteAuthorityMutation = { __typename?: 'GraphMutationApi'; deleteAuthority: any };

export type GetAuthoritiesAndDevicesCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetAuthoritiesAndDevicesCountQuery = {
  __typename?: 'GraphQueryApi';
  authoritiesAndDevicesCount: Array<{
    __typename?: 'AuthorityModel';
    id: any;
    name: string;
    cvr: string;
    isActive: boolean;
    deviceCount: number;
  }>;
};

export type GetAuthoritiesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAuthoritiesQuery = {
  __typename?: 'GraphQueryApi';
  authorities: Array<{
    __typename?: 'Authority';
    id: any;
    name: string;
    cvr: string;
    isActive?: boolean | undefined;
    createdAt?: any | undefined;
    updatedAt?: any | undefined;
    type: string;
  }>;
};

export type GetAuthorityQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type GetAuthorityQuery = {
  __typename?: 'GraphQueryApi';
  authority?:
    | {
        __typename?: 'Authority';
        id: any;
        name: string;
        cvr: string;
        isActive?: boolean | undefined;
        createdAt?: any | undefined;
        updatedAt?: any | undefined;
        type: string;
      }
    | undefined;
};

export type UpdateAuthorityMutationVariables = Exact<{
  input: AuthorityUpdateRequestInput;
}>;

export type UpdateAuthorityMutation = { __typename?: 'GraphMutationApi'; updateAuthority: any };

export type CheckExistingDeviceQueryVariables = Exact<{
  organisationId: Scalars['UUID'];
  deviceId: Scalars['String'];
}>;

export type CheckExistingDeviceQuery = {
  __typename?: 'GraphQueryApi';
  checkExistingDevice?: { __typename?: 'DeviceModel'; id: any; deviceId: string } | undefined;
};

export type CreateDeviceMutationVariables = Exact<{
  input: DeviceCreateRequestInput;
}>;

export type CreateDeviceMutation = {
  __typename?: 'GraphMutationApi';
  createDevice: {
    __typename?: 'Device';
    id: any;
    deviceId: string;
    organisationId: any;
    templateId: any;
    name?: string | undefined;
    stationNumber?: string | undefined;
    isActive?: boolean | undefined;
  };
};

export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type DeleteDeviceMutation = { __typename?: 'GraphMutationApi'; deleteDevice: any };

export type GetDeviceByDeviceIdQueryVariables = Exact<{
  deviceId: Scalars['String'];
}>;

export type GetDeviceByDeviceIdQuery = {
  __typename?: 'GraphQueryApi';
  deviceByDeviceId?:
    | {
        __typename?: 'DeviceModel';
        id: any;
        deviceId: string;
        organisationId: any;
        templateId: any;
        name?: string | undefined;
        stationNumber?: string | undefined;
        isActive: boolean;
        telemetryData?:
          | { __typename?: 'TelemetryData'; deviceId: string; dataLastReceived: any; latestPayload: string }
          | undefined;
      }
    | undefined;
};

export type GetDeviceQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type GetDeviceQuery = {
  __typename?: 'GraphQueryApi';
  device?:
    | {
        __typename?: 'DeviceModel';
        id: any;
        deviceId: string;
        organisationId: any;
        templateId: any;
        name?: string | undefined;
        stationNumber?: string | undefined;
        isActive: boolean;
        telemetryData?:
          | { __typename?: 'TelemetryData'; deviceId: string; dataLastReceived: any; latestPayload: string }
          | undefined;
      }
    | undefined;
};

export type GetDevicesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type GetDevicesQuery = {
  __typename?: 'GraphQueryApi';
  devices: Array<{
    __typename?: 'DeviceModel';
    id: any;
    deviceId: string;
    organisationId: any;
    templateId: any;
    templateName: string;
    name?: string | undefined;
    stationNumber?: string | undefined;
    isActive: boolean;
    telemetryData?:
      | { __typename?: 'TelemetryData'; deviceId: string; dataLastReceived: any; latestPayload: string }
      | undefined;
  }>;
};

export type TemplatesForDeviceQueryVariables = Exact<{ [key: string]: never }>;

export type TemplatesForDeviceQuery = {
  __typename?: 'GraphQueryApi';
  templatesForDevice: Array<{
    __typename?: 'TemplatesDeviceResponse';
    id: any;
    name: string;
    description?: string | undefined;
    type: string;
    createdAt?: any | undefined;
    updatedAt?: any | undefined;
    attributes: Array<{
      __typename?: 'TemplateAttributeDevice';
      id: any;
      sensorMapping: string;
      sc1009Name?: string | undefined;
      sc1187Name?: string | undefined;
      description?: string | undefined;
    }>;
  }>;
};

export type UpdateDeviceMutationVariables = Exact<{
  input: DeviceUpdateRequestInput;
}>;

export type UpdateDeviceMutation = { __typename?: 'GraphMutationApi'; updateDevice: any };

export type CreateTemplateMutationVariables = Exact<{
  input: TemplateCreateRequestInput;
}>;

export type CreateTemplateMutation = {
  __typename?: 'GraphMutationApi';
  createTemplate: {
    __typename?: 'Template';
    id: any;
    name: string;
    description?: string | undefined;
    templateId?: string | undefined;
    attributes: Array<{
      __typename?: 'TemplateAttribute';
      id: any;
      name?: string | undefined;
      unit?: string | undefined;
      sensorMapping: string;
      description?: string | undefined;
      sc1009Id?: any | undefined;
      sc1187Id?: any | undefined;
    }>;
  };
};

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type DeleteTemplateMutation = { __typename?: 'GraphMutationApi'; deleteTemplate: any };

export type GetStancodesQueryVariables = Exact<{ [key: string]: never }>;

export type GetStancodesQuery = {
  __typename?: 'GraphQueryApi';
  stancodes: Array<{
    __typename?: 'Stancode';
    id: any;
    scCode: number;
    descriptionText?: string | undefined;
    additionalDescriptionText?: string | undefined;
    createdAt?: any | undefined;
    updatedAt?: any | undefined;
    stancodeListId: any;
    stancodeGuidKey: any;
    codeReference: number;
    referenceTypeName?: string | undefined;
    lastUpdateDate?: any | undefined;
    creationDate?: any | undefined;
    obsolescenceDate?: any | undefined;
    applicantIdentificationText?: string | undefined;
    isDeleted: boolean;
    type: string;
  }>;
};

export type GetTemplateQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type GetTemplateQuery = {
  __typename?: 'GraphQueryApi';
  template?:
    | {
        __typename?: 'Template';
        id: any;
        name: string;
        description?: string | undefined;
        type: string;
        createdAt?: any | undefined;
        updatedAt?: any | undefined;
        templateId?: string | undefined;
        attributes: Array<{
          __typename?: 'TemplateAttribute';
          id: any;
          name?: string | undefined;
          unit?: string | undefined;
          sensorMapping: string;
          description?: string | undefined;
          sc1187Id?: any | undefined;
          sc1009Id?: any | undefined;
        }>;
      }
    | undefined;
};

export type GetTemplatesAndDevicesCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetTemplatesAndDevicesCountQuery = {
  __typename?: 'GraphQueryApi';
  templatesAndDevicesCount: Array<{
    __typename?: 'TemplateModel';
    id: any;
    name: string;
    description?: string | undefined;
    deviceCount: number;
    attributes: Array<{
      __typename?: 'TemplateAttributeModel';
      id: any;
      name: string;
      unit?: string | undefined;
      sensorMapping: string;
      description?: string | undefined;
      sc1009Id?: any | undefined;
      sc1187Id?: any | undefined;
    }>;
  }>;
};

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTemplatesQuery = {
  __typename?: 'GraphQueryApi';
  templates: Array<{
    __typename?: 'Template';
    id: any;
    name: string;
    description?: string | undefined;
    type: string;
    createdAt?: any | undefined;
    updatedAt?: any | undefined;
    templateId?: string | undefined;
    attributes: Array<{
      __typename?: 'TemplateAttribute';
      id: any;
      name?: string | undefined;
      unit?: string | undefined;
      sensorMapping: string;
      description?: string | undefined;
      sc1187Id?: any | undefined;
      sc1009Id?: any | undefined;
    }>;
  }>;
};

export type UpdateTemplateMutationVariables = Exact<{
  input: TemplateUpdateRequestInput;
}>;

export type UpdateTemplateMutation = { __typename?: 'GraphMutationApi'; updateTemplate: any };

export const GetProfileDocument = gql`
  query GetProfile {
    profile {
      userId
      name
      email
      cvr
      company
      roles
      isAdmin
      isAuthority
      isAuthorityExisting
      isAuthorityActive
    }
  }
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a Vue component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProfileQuery();
 */
export function useGetProfileQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetProfileQuery, GetProfileQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProfileQuery, GetProfileQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProfileQuery, GetProfileQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, {}, options);
}
export function useGetProfileLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetProfileQuery, GetProfileQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProfileQuery, GetProfileQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProfileQuery, GetProfileQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, {}, options);
}
export type GetProfileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetProfileQuery,
  GetProfileQueryVariables
>;
export const CreateAuthorityDocument = gql`
  mutation CreateAuthority($input: AuthorityCreateRequestInput!) {
    createAuthority(request: $input) {
      id
      name
      cvr
      isActive
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useCreateAuthorityMutation__
 *
 * To run a mutation, you first call `useCreateAuthorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAuthorityMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorityMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAuthorityMutation, CreateAuthorityMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAuthorityMutation, CreateAuthorityMutationVariables>
      > = {}
) {
  return VueApolloComposable.useMutation<CreateAuthorityMutation, CreateAuthorityMutationVariables>(
    CreateAuthorityDocument,
    options
  );
}
export type CreateAuthorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAuthorityMutation,
  CreateAuthorityMutationVariables
>;
export const DeleteAuthorityDocument = gql`
  mutation DeleteAuthority($id: UUID!) {
    deleteAuthority(id: $id)
  }
`;

/**
 * __useDeleteAuthorityMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAuthorityMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAuthorityMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAuthorityMutation, DeleteAuthorityMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteAuthorityMutation, DeleteAuthorityMutationVariables>
      > = {}
) {
  return VueApolloComposable.useMutation<DeleteAuthorityMutation, DeleteAuthorityMutationVariables>(
    DeleteAuthorityDocument,
    options
  );
}
export type DeleteAuthorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAuthorityMutation,
  DeleteAuthorityMutationVariables
>;
export const GetAuthoritiesAndDevicesCountDocument = gql`
  query GetAuthoritiesAndDevicesCount {
    authoritiesAndDevicesCount {
      id
      name
      cvr
      isActive
      deviceCount
    }
  }
`;

/**
 * __useGetAuthoritiesAndDevicesCountQuery__
 *
 * To run a query within a Vue component, call `useGetAuthoritiesAndDevicesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthoritiesAndDevicesCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuthoritiesAndDevicesCountQuery();
 */
export function useGetAuthoritiesAndDevicesCountQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuthoritiesAndDevicesCountQuery,
        GetAuthoritiesAndDevicesCountQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuthoritiesAndDevicesCountQuery,
          GetAuthoritiesAndDevicesCountQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuthoritiesAndDevicesCountQuery,
          GetAuthoritiesAndDevicesCountQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<GetAuthoritiesAndDevicesCountQuery, GetAuthoritiesAndDevicesCountQueryVariables>(
    GetAuthoritiesAndDevicesCountDocument,
    {},
    options
  );
}
export function useGetAuthoritiesAndDevicesCountLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuthoritiesAndDevicesCountQuery,
        GetAuthoritiesAndDevicesCountQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuthoritiesAndDevicesCountQuery,
          GetAuthoritiesAndDevicesCountQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuthoritiesAndDevicesCountQuery,
          GetAuthoritiesAndDevicesCountQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useLazyQuery<
    GetAuthoritiesAndDevicesCountQuery,
    GetAuthoritiesAndDevicesCountQueryVariables
  >(GetAuthoritiesAndDevicesCountDocument, {}, options);
}
export type GetAuthoritiesAndDevicesCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuthoritiesAndDevicesCountQuery,
  GetAuthoritiesAndDevicesCountQueryVariables
>;
export const GetAuthoritiesDocument = gql`
  query GetAuthorities {
    authorities {
      id
      name
      cvr
      isActive
      createdAt
      updatedAt
      type
    }
  }
`;

/**
 * __useGetAuthoritiesQuery__
 *
 * To run a query within a Vue component, call `useGetAuthoritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthoritiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuthoritiesQuery();
 */
export function useGetAuthoritiesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>(
    GetAuthoritiesDocument,
    {},
    options
  );
}
export function useGetAuthoritiesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetAuthoritiesQuery, GetAuthoritiesQueryVariables>(
    GetAuthoritiesDocument,
    {},
    options
  );
}
export type GetAuthoritiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuthoritiesQuery,
  GetAuthoritiesQueryVariables
>;
export const GetAuthorityDocument = gql`
  query GetAuthority($id: UUID!) {
    authority(id: $id) {
      id
      name
      cvr
      isActive
      createdAt
      updatedAt
      type
    }
  }
`;

/**
 * __useGetAuthorityQuery__
 *
 * To run a query within a Vue component, call `useGetAuthorityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuthorityQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAuthorityQuery(
  variables:
    | GetAuthorityQueryVariables
    | VueCompositionApi.Ref<GetAuthorityQueryVariables>
    | ReactiveFunction<GetAuthorityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAuthorityQuery, GetAuthorityQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthorityQuery, GetAuthorityQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthorityQuery, GetAuthorityQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetAuthorityQuery, GetAuthorityQueryVariables>(
    GetAuthorityDocument,
    variables,
    options
  );
}
export function useGetAuthorityLazyQuery(
  variables:
    | GetAuthorityQueryVariables
    | VueCompositionApi.Ref<GetAuthorityQueryVariables>
    | ReactiveFunction<GetAuthorityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAuthorityQuery, GetAuthorityQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthorityQuery, GetAuthorityQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthorityQuery, GetAuthorityQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetAuthorityQuery, GetAuthorityQueryVariables>(
    GetAuthorityDocument,
    variables,
    options
  );
}
export type GetAuthorityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuthorityQuery,
  GetAuthorityQueryVariables
>;
export const UpdateAuthorityDocument = gql`
  mutation UpdateAuthority($input: AuthorityUpdateRequestInput!) {
    updateAuthority(request: $input)
  }
`;

/**
 * __useUpdateAuthorityMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAuthorityMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorityMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAuthorityMutation, UpdateAuthorityMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAuthorityMutation, UpdateAuthorityMutationVariables>
      > = {}
) {
  return VueApolloComposable.useMutation<UpdateAuthorityMutation, UpdateAuthorityMutationVariables>(
    UpdateAuthorityDocument,
    options
  );
}
export type UpdateAuthorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAuthorityMutation,
  UpdateAuthorityMutationVariables
>;
export const CheckExistingDeviceDocument = gql`
  query CheckExistingDevice($organisationId: UUID!, $deviceId: String!) {
    checkExistingDevice(organisationId: $organisationId, deviceId: $deviceId) {
      id
      deviceId
    }
  }
`;

/**
 * __useCheckExistingDeviceQuery__
 *
 * To run a query within a Vue component, call `useCheckExistingDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExistingDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckExistingDeviceQuery({
 *   organisationId: // value for 'organisationId'
 *   deviceId: // value for 'deviceId'
 * });
 */
export function useCheckExistingDeviceQuery(
  variables:
    | CheckExistingDeviceQueryVariables
    | VueCompositionApi.Ref<CheckExistingDeviceQueryVariables>
    | ReactiveFunction<CheckExistingDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>
      > = {}
) {
  return VueApolloComposable.useQuery<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>(
    CheckExistingDeviceDocument,
    variables,
    options
  );
}
export function useCheckExistingDeviceLazyQuery(
  variables:
    | CheckExistingDeviceQueryVariables
    | VueCompositionApi.Ref<CheckExistingDeviceQueryVariables>
    | ReactiveFunction<CheckExistingDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>
      > = {}
) {
  return VueApolloComposable.useLazyQuery<CheckExistingDeviceQuery, CheckExistingDeviceQueryVariables>(
    CheckExistingDeviceDocument,
    variables,
    options
  );
}
export type CheckExistingDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CheckExistingDeviceQuery,
  CheckExistingDeviceQueryVariables
>;
export const CreateDeviceDocument = gql`
  mutation CreateDevice($input: DeviceCreateRequestInput!) {
    createDevice(request: $input) {
      id
      deviceId
      organisationId
      templateId
      name
      stationNumber
      isActive
    }
  }
`;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDeviceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>> = {}
) {
  return VueApolloComposable.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(
    CreateDeviceDocument,
    options
  );
}
export type CreateDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateDeviceMutation,
  CreateDeviceMutationVariables
>;
export const DeleteDeviceDocument = gql`
  mutation DeleteDevice($id: UUID!) {
    deleteDevice(id: $id)
  }
`;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>> = {}
) {
  return VueApolloComposable.useMutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(
    DeleteDeviceDocument,
    options
  );
}
export type DeleteDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDeviceMutation,
  DeleteDeviceMutationVariables
>;
export const GetDeviceByDeviceIdDocument = gql`
  query GetDeviceByDeviceId($deviceId: String!) {
    deviceByDeviceId(deviceId: $deviceId) {
      id
      deviceId
      organisationId
      templateId
      name
      stationNumber
      isActive
      telemetryData {
        deviceId
        dataLastReceived
        latestPayload
      }
    }
  }
`;

/**
 * __useGetDeviceByDeviceIdQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByDeviceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByDeviceIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByDeviceIdQuery({
 *   deviceId: // value for 'deviceId'
 * });
 */
export function useGetDeviceByDeviceIdQuery(
  variables:
    | GetDeviceByDeviceIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceByDeviceIdQueryVariables>
    | ReactiveFunction<GetDeviceByDeviceIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>
      > = {}
) {
  return VueApolloComposable.useQuery<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>(
    GetDeviceByDeviceIdDocument,
    variables,
    options
  );
}
export function useGetDeviceByDeviceIdLazyQuery(
  variables:
    | GetDeviceByDeviceIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceByDeviceIdQueryVariables>
    | ReactiveFunction<GetDeviceByDeviceIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>
      > = {}
) {
  return VueApolloComposable.useLazyQuery<GetDeviceByDeviceIdQuery, GetDeviceByDeviceIdQueryVariables>(
    GetDeviceByDeviceIdDocument,
    variables,
    options
  );
}
export type GetDeviceByDeviceIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByDeviceIdQuery,
  GetDeviceByDeviceIdQueryVariables
>;
export const GetDeviceDocument = gql`
  query GetDevice($id: UUID!) {
    device(id: $id) {
      id
      deviceId
      organisationId
      templateId
      name
      stationNumber
      isActive
      telemetryData {
        deviceId
        dataLastReceived
        latestPayload
      }
    }
  }
`;

/**
 * __useGetDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceQuery(
  variables:
    | GetDeviceQueryVariables
    | VueCompositionApi.Ref<GetDeviceQueryVariables>
    | ReactiveFunction<GetDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceQuery, GetDeviceQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDeviceQuery, GetDeviceQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDeviceQuery, GetDeviceQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetDeviceQuery, GetDeviceQueryVariables>(GetDeviceDocument, variables, options);
}
export function useGetDeviceLazyQuery(
  variables:
    | GetDeviceQueryVariables
    | VueCompositionApi.Ref<GetDeviceQueryVariables>
    | ReactiveFunction<GetDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceQuery, GetDeviceQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDeviceQuery, GetDeviceQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDeviceQuery, GetDeviceQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetDeviceQuery, GetDeviceQueryVariables>(
    GetDeviceDocument,
    variables,
    options
  );
}
export type GetDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceQuery,
  GetDeviceQueryVariables
>;
export const GetDevicesDocument = gql`
  query GetDevices($id: UUID!) {
    devices(organisationId: $id) {
      id
      deviceId
      organisationId
      templateId
      templateName
      name
      stationNumber
      isActive
      telemetryData {
        deviceId
        dataLastReceived
        latestPayload
      }
    }
  }
`;

/**
 * __useGetDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDevicesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDevicesQuery(
  variables:
    | GetDevicesQueryVariables
    | VueCompositionApi.Ref<GetDevicesQueryVariables>
    | ReactiveFunction<GetDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDevicesQuery, GetDevicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDevicesQuery, GetDevicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDevicesQuery, GetDevicesQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetDevicesQuery, GetDevicesQueryVariables>(
    GetDevicesDocument,
    variables,
    options
  );
}
export function useGetDevicesLazyQuery(
  variables:
    | GetDevicesQueryVariables
    | VueCompositionApi.Ref<GetDevicesQueryVariables>
    | ReactiveFunction<GetDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDevicesQuery, GetDevicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDevicesQuery, GetDevicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDevicesQuery, GetDevicesQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetDevicesQuery, GetDevicesQueryVariables>(
    GetDevicesDocument,
    variables,
    options
  );
}
export type GetDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDevicesQuery,
  GetDevicesQueryVariables
>;
export const TemplatesForDeviceDocument = gql`
  query TemplatesForDevice {
    templatesForDevice {
      id
      name
      description
      type
      createdAt
      updatedAt
      attributes {
        id
        sensorMapping
        sc1009Name
        sc1187Name
        description
      }
    }
  }
`;

/**
 * __useTemplatesForDeviceQuery__
 *
 * To run a query within a Vue component, call `useTemplatesForDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesForDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTemplatesForDeviceQuery();
 */
export function useTemplatesForDeviceQuery(
  options:
    | VueApolloComposable.UseQueryOptions<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>
      > = {}
) {
  return VueApolloComposable.useQuery<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>(
    TemplatesForDeviceDocument,
    {},
    options
  );
}
export function useTemplatesForDeviceLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>
      > = {}
) {
  return VueApolloComposable.useLazyQuery<TemplatesForDeviceQuery, TemplatesForDeviceQueryVariables>(
    TemplatesForDeviceDocument,
    {},
    options
  );
}
export type TemplatesForDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  TemplatesForDeviceQuery,
  TemplatesForDeviceQueryVariables
>;
export const UpdateDeviceDocument = gql`
  mutation UpdateDevice($input: DeviceUpdateRequestInput!) {
    updateDevice(request: $input)
  }
`;

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDeviceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>> = {}
) {
  return VueApolloComposable.useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(
    UpdateDeviceDocument,
    options
  );
}
export type UpdateDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDeviceMutation,
  UpdateDeviceMutationVariables
>;
export const CreateTemplateDocument = gql`
  mutation CreateTemplate($input: TemplateCreateRequestInput!) {
    createTemplate(request: $input) {
      id
      name
      description
      templateId
      attributes {
        id
        name
        unit
        sensorMapping
        description
        sc1009Id
        sc1187Id
      }
    }
  }
`;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>
      > = {}
) {
  return VueApolloComposable.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(
    CreateTemplateDocument,
    options
  );
}
export type CreateTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateTemplateMutation,
  CreateTemplateMutationVariables
>;
export const DeleteTemplateDocument = gql`
  mutation DeleteTemplate($id: UUID!) {
    deleteTemplate(id: $id)
  }
`;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>
      > = {}
) {
  return VueApolloComposable.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(
    DeleteTemplateDocument,
    options
  );
}
export type DeleteTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteTemplateMutation,
  DeleteTemplateMutationVariables
>;
export const GetStancodesDocument = gql`
  query GetStancodes {
    stancodes {
      id
      scCode
      descriptionText
      additionalDescriptionText
      createdAt
      updatedAt
      stancodeListId
      stancodeGuidKey
      codeReference
      referenceTypeName
      lastUpdateDate
      creationDate
      obsolescenceDate
      applicantIdentificationText
      isDeleted
      type
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetStancodesQuery__
 *
 * To run a query within a Vue component, call `useGetStancodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStancodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStancodesQuery();
 */
export function useGetStancodesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetStancodesQuery, GetStancodesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStancodesQuery, GetStancodesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStancodesQuery, GetStancodesQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetStancodesQuery, GetStancodesQueryVariables>(GetStancodesDocument, {}, options);
}
export function useGetStancodesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetStancodesQuery, GetStancodesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStancodesQuery, GetStancodesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStancodesQuery, GetStancodesQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetStancodesQuery, GetStancodesQueryVariables>(
    GetStancodesDocument,
    {},
    options
  );
}
export type GetStancodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetStancodesQuery,
  GetStancodesQueryVariables
>;
export const GetTemplateDocument = gql`
  query GetTemplate($id: UUID!) {
    template(id: $id) {
      id
      name
      description
      type
      createdAt
      updatedAt
      templateId
      attributes {
        id
        name
        unit
        sensorMapping
        description
        sc1187Id
        sc1009Id
      }
    }
  }
`;

/**
 * __useGetTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTemplateQuery(
  variables:
    | GetTemplateQueryVariables
    | VueCompositionApi.Ref<GetTemplateQueryVariables>
    | ReactiveFunction<GetTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetTemplateQuery, GetTemplateQueryVariables>(
    GetTemplateDocument,
    variables,
    options
  );
}
export function useGetTemplateLazyQuery(
  variables:
    | GetTemplateQueryVariables
    | VueCompositionApi.Ref<GetTemplateQueryVariables>
    | ReactiveFunction<GetTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetTemplateQuery, GetTemplateQueryVariables>(
    GetTemplateDocument,
    variables,
    options
  );
}
export type GetTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTemplateQuery,
  GetTemplateQueryVariables
>;
export const GetTemplatesAndDevicesCountDocument = gql`
  query GetTemplatesAndDevicesCount {
    templatesAndDevicesCount {
      id
      name
      description
      deviceCount
      attributes {
        id
        name
        unit
        sensorMapping
        description
        sc1009Id
        sc1187Id
      }
    }
  }
`;

/**
 * __useGetTemplatesAndDevicesCountQuery__
 *
 * To run a query within a Vue component, call `useGetTemplatesAndDevicesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesAndDevicesCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTemplatesAndDevicesCountQuery();
 */
export function useGetTemplatesAndDevicesCountQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>
      > = {}
) {
  return VueApolloComposable.useQuery<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>(
    GetTemplatesAndDevicesCountDocument,
    {},
    options
  );
}
export function useGetTemplatesAndDevicesCountLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>
      > = {}
) {
  return VueApolloComposable.useLazyQuery<GetTemplatesAndDevicesCountQuery, GetTemplatesAndDevicesCountQueryVariables>(
    GetTemplatesAndDevicesCountDocument,
    {},
    options
  );
}
export type GetTemplatesAndDevicesCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTemplatesAndDevicesCountQuery,
  GetTemplatesAndDevicesCountQueryVariables
>;
export const GetTemplatesDocument = gql`
  query GetTemplates {
    templates {
      id
      name
      description
      type
      createdAt
      updatedAt
      templateId
      attributes {
        id
        name
        unit
        sensorMapping
        description
        sc1187Id
        sc1009Id
      }
    }
  }
`;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTemplatesQuery();
 */
export function useGetTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>> = {}
) {
  return VueApolloComposable.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, {}, options);
}
export function useGetTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>> = {}
) {
  return VueApolloComposable.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(
    GetTemplatesDocument,
    {},
    options
  );
}
export type GetTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTemplatesQuery,
  GetTemplatesQueryVariables
>;
export const UpdateTemplateDocument = gql`
  mutation UpdateTemplate($input: TemplateUpdateRequestInput!) {
    updateTemplate(request: $input)
  }
`;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>
      > = {}
) {
  return VueApolloComposable.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(
    UpdateTemplateDocument,
    options
  );
}
export type UpdateTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateTemplateMutation,
  UpdateTemplateMutationVariables
>;
